<template>
  <v-app id="app_measurements">

    <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
      <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">ORGANIZATION LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Organization and their enabied functlanalitles in
            the system.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-btn class="custom_hedging_btn_primary" size="x-large" variant="text" to="/create-organization">
              <v-icon>mdi-file-upload-outline</v-icon>&nbsp;&nbsp;CREATE ORGANIZATION
            </v-btn>
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="true" rounded="lg">
        <v-card-text class="custom_tool_bar_style d-flex align-center">

          <div class="d-flex align-center">
            <v-btn class="custom_measurement_btn" variant="outlined" @click="defaulttheme_dialog = true"
              v-if="permissions.write">
              &nbsp;&nbsp;SET DEFAULT THEME
            </v-btn>
            <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
          </div>
        </v-card-text>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <!-- search bar -->
        <v-row align="center" justify="end">
          <v-col cols="12" md="4">
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details label="Search"
              placeholder="Search " variant="outlined" class="custom_input_field_color"
              density="comfortable"></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-2" style="height: 2px;"></v-divider>
        <v-data-table :headers="headers" :items="filteredOrganizations" :search="search" :items-per-page="itemsPerPage"
    class="elevation-1">

    <!-- Logo - Web Column -->
    <template v-slot:[`item.logo_web`]="{ item }">
      <div class="products-column mb-2 mt-2">
        <div class="d-flex align-center">
          <img :src="item.organization_logo_web != 'Not Found' ? `${imageURL}/${item.organization_logo_web}` : `${defaultImage}`"
              class="product-image mr-3 mb-2" max-height="50" max-width="50"/>
        </div>
      </div>
    </template>

    <!-- Logo - Mobile Column -->
    <template v-slot:[`item.logo_mobile`]="{ item }">
      <div class="products-column mb-2 mt-2">
        <div class="d-flex align-center">
          <img :src="item.organization_logo_mobile != 'Not Found' ? `${imageURL}/${item.organization_logo_mobile}` : `${defaultImage}`"
              class="product-image mr-3 mb-2" max-height="50" max-width="50"/>
        </div>
      </div>
    </template>

    <!-- Primary Color Column (Color Box + Color Code in Line) -->
    <template v-slot:[`item.Primary_color`]="{ item }">
      <div class="d-flex align-center">
        <div class="color-box mr-2" :style="{ backgroundColor: item.organization_color }"></div>
        <span class="color-code">{{ item.organization_color }}</span>
      </div>
    </template>

    <!-- Creation Date Column -->
    <template v-slot:[`item.Creating_date`]="{ item }">
      {{ new Date(item.created_at).toISOString().split('T')[0] }}
    </template>

    <!-- Actions Column -->
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu transition="slide-x-transition" id="app_product_list">
        <template v-slot:activator="{ props }">
          <v-btn class="custom_btn_primary" variant="flat" size="large" v-bind="props">
            ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="permissions.read" @click="OpenOrganizationViewDialog(item)">
            <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="permissions.write" @click="OpenOrganizationEditDialog(item)">
            <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
            <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="permissions.delete" @click="setTheme(item)">
            <v-list-item-title class="custom_font_color_setTheme">Set Theme</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>


        <v-pagination v-model="page" :length="totalPages" @input="changePage" class="my-4"></v-pagination>

      </v-card>
      <v-dialog v-model="dialog" max-height="700" id="app_lead_list" max-width="600">
        <v-card rounded="md" style="overflow:hidden !important;">
          <div class="pa-4">
            <!-- Dialog Title -->
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">{{ dialogTitle }}</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="closeDialog" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-text-field v-model="measurementName" label="Measurement Name*" placeholder="Create measurement name"
                  variant="outlined" required :rules="[rules.textOnly]"></v-text-field>

                <v-text-field v-model="unit" label="Unit*" placeholder="Create unit name" variant="outlined" required
                  :rules="[rules.textOnly]"></v-text-field>

                <!--                <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="280" min-height="280">-->
                <!--                  <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>-->
                <!--                  <v-divider></v-divider>-->
                <!--                  <Editor aria-placeholder="Type Hear..." v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode"-->
                <!--                          @onCreated="handleCreated"/>-->
                <!--                </v-card>-->

                <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="280" min-height="280">
                  <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
                  <v-divider></v-divider>
                  <Editor aria-placeholder="Type Here..." v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode"
                    @onCreated="handleCreated" @onChange="handleEditorChange" />

                </v-card>
                <v-card-text class="text-caption text-right">
                  Word Count: {{ charCount }}/100
                </v-card-text>

              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" variant="flat" @click="saveMeasurement">{{ dialogButtonText }}</v-btn>
              <v-btn variant="outlined" @click="closeDialog">CANCEL</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="delete_measurement_dialog" max-height="500" max-width="500" persistent id="app_product_list">
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE ORGANIZATION</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_measurement_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this Organization ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This Organization will be deleted immediately. Once deleted, it can no longer be used in any purpose.
                  <span style="color: blue;">
                    Further, these modules are also related to the following other module also, so please read and
                    confirm
                    before
                    deleting this.
                  </span>
                </p>

                <v-timeline align="start" density="compact">
                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <div class="text-h6">related area 01</div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et
                        dolore magna aliqua.
                      </p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <div class="text-h6">related area 02</div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et
                        dolore magna aliqua.
                      </p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <p>related area 02</p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <p>related area 02</p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <p>related area 02</p>
                    </div>
                  </v-timeline-item>

                  <v-timeline-item>
                    <template v-slot:opposite>

                    </template>
                    <div>
                      <p>related area 02</p>
                    </div>
                  </v-timeline-item>
                </v-timeline>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteItems">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="delete_measurement_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>



      <v-dialog v-model="defaulttheme_dialog" max-height="500" max-width="500" persistent id="app_product_list">
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">SET DEFAULT THEME</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="defaulttheme_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to set default theme ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  Here again, the system's colors all change to the same state as they were at the beginning.
                </p>



                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteItems">YES,CHANGE IT</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="defaulttheme_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>


      <v-dialog v-model="view_organization_dialog" fullscreen id="view_organization_dialog">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo_full_5.png')" width="100"
                height="auto" @click="homeReload()">
              </v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_red_btn" variant="flat" @click="view_organization_dialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-4 ">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">ORGANIZATION
                    DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1">
                <v-row class="ma-0 mb-2" align="center">
                  <v-col cols="8">
                  <v-text style="font-size: 18px; ">Organization Name : {{ this.OrganizationDetails.organization_name }}</v-text>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <v-btn
                          v-if="permissions.write"
                          class="mr-3 custom_edit_btn"
                          icon rounded size="small"
                          variant="outlined" @click="OpenOrganizationEditDialog(OrganizationDetails)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                      </v-btn>

                    <v-btn v-if="permissions.delete" class="custom_delete_btn" icon rounded size="small"
                      variant="outlined" @click="confirmDelete(product)">
                      <v-icon>mdi-trash-can</v-icon>
                      <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                    </v-btn>


                  </v-col>
                </v-row>
              </v-card>


              <v-card class="pa-5 mt-3">

          <!-- Form Section -->
          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-text-field label="Organization Name *" placeholder="Type Organization name here" variant="outlined"
                density="comfortable" v-model="OrganizationDetails.organization_name" readonly></v-text-field>


                <v-text-field label="Color" placeholder="Type Organization name here" variant="outlined"
                density="comfortable" v-model="organizationColor" readonly></v-text-field>

              <!-- Organization Logo-Web Upload -->
              <v-card flat>
              <v-text class="font-weight-bold">Organization Logo - Web</v-text>
              <v-img
                class="mt-3"
                :width="650"
                :height="200"
                cover
                :src="OrganizationDetails.organization_logo_web != 'Not Found' ? `${imageURL}/${OrganizationDetails.organization_logo_web}` : `${defaultImage}`">
              </v-img>


              <!-- Organization Logo - Mobile -->
              <v-text class="font-weight-bold mt-5">Organization Logo - Mobile</v-text>
              <v-img
                class="mt-3"
                :width="650"
                :height="200"
                cover
                :src="OrganizationDetails.organization_logo_mobile != 'Not Found' ? `${imageURL}/${OrganizationDetails.organization_logo_mobile}` : `${defaultImage}`">
              </v-img>
            </v-card>
                  </v-col>

                  <!-- Setup Functionalities Section -->
            <v-col cols="6">
              <p class="custom_card_title">Setup Functionalities</p>
              <v-card class="mb-1 mt-4 custom_card_box" rounded="lg">
                <v-container>
                  <v-row v-for="(item) in permissionsItems" :key="item.id" >
                    <v-col cols="12">
                      <v-checkbox v-model="item.isOn" color="primary" hide-details class="ml-5" readonly>
                        <template v-slot:label>
                          <span :class="{
                            custom_page_main_sub_title_very_small_red:
                              item.isOn,
                            'grey-text': !item.isOn,
                            }" class="font-weight-medium text-body-2 ml-3">
                              {{ item.premission_dashboard }}
                            </span>
                        </template>
                      </v-checkbox>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>



                </v-row>
              </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>






      <v-dialog v-model="edit_organization_dialog" fullscreen id="edit_organization_dialog">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo_full_5.png')" width="100"
                height="auto" @click="homeReload()">
              </v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_red_btn" variant="flat" @click="edit_organization_dialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-4 ">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE ORGANIZATION
                    DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1">
                  <v-row class="ma-0 mb-2" align="center">
                    <v-col cols="8">
                      <v-text style="font-size: 18px;">Organization Name :{{ this.OrganizationDetails.organization_name }}</v-text>
                    </v-col>
                    <v-col cols="4" class="text-right">
                      <div class="d-flex align-center justify-end">
                        <v-btn
                        class="custom_measurement_btn mx-2"
                        variant="outlined"
                        @click="updateOrganizationDetails"
                        v-if="permissions.write"
                        style="background-color: #d4e6f1 ; color:#3498db ; border-color: #3498db ;">
                        &nbsp;&nbsp;UPDATE ORGANIZATION DATA
                      </v-btn>
                  <v-btn class="custom_measurement_btn mx-2" variant="outlined" @click="defaulttheme_dialog = true" v-if="permissions.write">
                    &nbsp;&nbsp;CANCEL
                  </v-btn>
                </div>


                  </v-col>
                </v-row>
              </v-card>

              <v-card class="pa-5 mt-3">

          <!-- Form Section -->
          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-text-field label="Organization Name *" placeholder="Type Organization name here" variant="outlined"
                density="comfortable"  v-model="organization.name"></v-text-field>


                <!-- <v-text-field label="Color" placeholder="Type Organization name here" variant="outlined"
                density="comfortable" v-model="organization.color"></v-text-field> -->

                <v-chip size="small">Previous Color: {{ organization.color}}</v-chip>
                <br>
                    <v-chip size="small" class="mt-2" v-if="changeColor">Selected Color: {{
                        getColorName(changeColor)
                      }}
                    </v-chip>
              <v-divider class="mb-2 mt-2"></v-divider>
              <v-text-field class="mt-3 custom_input_field_color" v-model="changeColor" density="comfortable"
                label="Color" variant="outlined" @click="dialogColor = true"></v-text-field>

              <v-dialog v-model="dialogColor" max-width="350px">
                <v-card id="app_authentication" rounded="md">
                  <div class="pa-4">
                    <v-card color="#F0F0F0" flat>
                      <template v-slot:prepend>
                        <v-card-title class="text-subtitle-1 font-weight-bold">SET YOUR COLOR CODE</v-card-title>
                      </template>
                      <v-spacer></v-spacer>
                      <template v-slot:append>
                        <v-btn @click="dialogColor = false" icon="mdi-close" size="x-small"></v-btn>
                      </template>
                    </v-card>

                    <!-- Color Code Text Field -->
                    <v-text-field v-model="changeColor" class="mt-4 custom_input_field_color" label="Color Code"
                      density="comfortable" placeholder="Type your color code here" variant="outlined"></v-text-field>

                    <!-- Mode Selector -->
                    <!-- <v-autocomplete
                        v-model="mode"
                        :items="modes"
                        class="custom_input_field_color"
                        density="comfortable"
                        variant="outlined"
                      ></v-autocomplete> -->

                    <!-- Color Picker -->
                    <v-color-picker width="318px" v-model="changeColor" v-model:mode="mode"></v-color-picker>

                    <v-divider class="mt-3"></v-divider>

                    <div class="float-end mt-4">
                      <v-btn size="large" color="blue" @click="dialogColor = false">ADD</v-btn>
                    </div>
                  </div>
                </v-card>
              </v-dialog>




              <div>
              <!-- Organization Logo-Web Upload -->
              <v-card flat v-if="!isEditingWebImage">
              <v-text class="font-weight-bold">Organization Logo - Web</v-text>


              <div >
              <v-img
                class="mt-3"
                :width="650"
                :height="200"
                cover
                :src="OrganizationDetails.organization_logo_web != 'Not Found' ? `${imageURL}/${OrganizationDetails.organization_logo_web}` : `${defaultImage}`">
              </v-img>
              <!-- Change Button (Absolute Positioned to the Right) -->
              <v-btn
                @click="changeImageWeb"
                color="primary"
                style="position: absolute; right: 90px; bottom: 8px;">
                CHANGE
              </v-btn>
            </div>
            </v-card>

            <v-card flat v-else>
              <v-text class="font-weight-bold">Organization Logo - Web</v-text>
              <div class="drop-area" @click="triggerFileInput" @drop.prevent="onDrop"
                   @dragover.prevent="onDragOver">
                <input ref="fileInput" accept="image/*" class="hidden-file-input" multiple type="file"
                       @change="onFileChange"/>

                <div v-if="previewImages.length > 0" class="image-card-container">
                  <v-card class="image-card">
                    <v-img :src="previewImages[0]" alt="Image preview" class="image-preview"></v-img>
                    <v-btn class="remove-icon" icon size="x-small" @click.stop="removeImage(0)">
                      <v-icon color="red" size="small">mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </div>
                <div v-if="previewImages.length === 0" class="placeholder-container">
                  <v-icon size="36">mdi-cloud-upload</v-icon>
                  <span>Drag your photo here OR click to <span
                      style="color:#156CF7;">Browse from device</span></span>
                </div>
              </div>
            </v-card>
      </div>




              <!-- Organization Logo - Mobile -->
               <div>
                <v-card flat class="mt-10" v-if="!isEditingMoblieImage">
                  <v-text class="font-weight-bold mt-5">Organization Logo - Mobile</v-text>
                  <v-img
                    class="mt-3"
                    :width="650"
                    :height="200"
                    cover
                    :src="OrganizationDetails.organization_logo_mobile != 'Not Found' ? `${imageURL}/${OrganizationDetails.organization_logo_mobile}` : `${defaultImage}`">
                  </v-img>

                  <v-btn
                    @click="changeImageMobile"
                    color="primary"
                    style="position: absolute; right: 90px; bottom: 8px;">
                    CHANGE
                  </v-btn>
                </v-card>

                <v-card flat v-else class="mt-10">
                  <v-text class="font-weight-bold mt-5">Organization Logo - Mobile</v-text>
                <div class="drop-area" @click="triggerFileInputMobile" @drop.prevent="onDrop"
                       @dragover.prevent="onDragOver">
                    <input ref="fileInputMobile" accept="image/*" class="hidden-file-input" multiple type="file"
                           @change="onFileChangeMobile"/>

                    <div v-if="previewImagesMobile.length > 0" class="image-card-container">
                      <v-card class="image-card">
                        <v-img :src="previewImagesMobile[0]" alt="Image preview" class="image-preview"></v-img>
                        <v-btn class="remove-icon" icon size="x-small" @click.stop="removeImageMobile(0)">
                          <v-icon color="red" size="small">mdi-delete</v-icon>
                        </v-btn>
                      </v-card>
                    </div>
                    <div v-if="previewImagesMobile.length === 0" class="placeholder-container">
                      <v-icon size="36">mdi-cloud-upload</v-icon>
                      <span>Drag your photo here OR click to <span
                          style="color:#156CF7;">Browse from device</span></span>
                    </div>
                  </div>

              </v-card>
            </div>
            </v-col>

            <!-- Setup Functionalities Section -->
            <v-col cols="6">
              <p class="custom_card_title">Setup Functionalities</p>
              <v-card class="mb-1 mt-4 custom_card_box" rounded="lg">
                <v-container>
                  <v-row v-for="(item) in permissionsItems" :key="item.id" >
                    <v-col cols="12">
                      <v-checkbox v-model="item.isOn" color="primary" hide-details class="ml-5" >
                        <template v-slot:label>
                          <span :class="{
                            custom_page_main_sub_title_very_small_red:
                              item.isOn,
                            'grey-text': !item.isOn,
                            }" class="font-weight-medium text-body-2 ml-3">
                              {{ item.premission_dashboard }}
                            </span>
                        </template>
                      </v-checkbox>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>


      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" location="top-right" outlined>
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>


      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
// import { onBeforeUnmount, onMounted, ref, shallowRef } from "vue";
// import axios from "axios";
import { getPermissions } from "@/plugins/permissions";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import DOMPurify from "dompurify";
import axios from 'axios';
import ntc from 'ntc';

export default {
  components: {
    Editor,
    Toolbar,
  },

  name: 'MeasurementList',
  data() {

    return {
      Organizationset: [],

      items: [
        { text: "Dashboard", isOn: true },
        { text: "Product Management", isOn: true },
        { text: "Leads Management", isOn: true },
        { text: "User Management", isOn: true },
        { text: "Sales Management", isOn: true },
        { text: "Collection Management", isOn: true },
        { text: "Tracking Management", isOn: true },
        { text: "Route Management", isOn: true },
        { text: "Outlet Management", isOn: true },
      ],


      imageURL:"",
      dialogColor:false,
      changeColor:"",
      OrganizationDetails:{},
      organizationColor:"",
      permissionsItems: [],
      isEditingWebImage: false,
      isEditingMoblieImage:false,
      previewImages: [],
      previewImagesMobile:[],
      organization: {
        name: '',
        color: '#0000FF',
        webLogo: null,
        mobileLogo: null,
      },
      rules: {
        textOnly: v => /^[A-Za-z\s]+$/.test(v) || "Only text is allowed",
      },
      charCount: 0,
      charLimit: 100,
      permissions: {},
      search: "",
      page: 1,
      itemsPerPage: 10,
      dialog: false,
      // dialogTitle: 'CREATE MEASUREMENTS',
      dialogButtonText: 'CREATE',
      measurementName: '',
      selectedProductId: null,
      unit: '',
      description: '',
      measurementUnits: [""],
      delete_measurement_dialog: false,
      MeasurementBulkUploadDialog: false,
      defaulttheme_dialog: false,
      view_organization_dialog: false,
      edit_organization_dialog: false,
      previousColor:"",
      bulkFile: null,
      bulkItems: [],
      organizationId:"",
      bulkHeaders: [
        { text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name' },
        { text: 'Unit', value: 'Unit', title: 'Unit' },
        { text: 'Description', value: 'Description', title: 'Description' },
        { text: 'Actions', value: 'actions', title: 'Actions', sortable: false } // Add the Actions column
      ],
      bulkHeadersTwo: [
        { text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name' },
        { text: 'Unit', value: 'Unit', title: 'Unit' },
        { text: 'Description', value: 'Description', title: 'Description' },
      ],
      headers: [
        { text: "Logo-Web", value: "logo_web", title: 'Logo-Web', sortable: true },
        { text: "Logo-Mobile", value: "logo_mobile", title: 'Logo-Mobile', sortable: true },
        { text: "Organization", value: "organization_name", title: 'Organization', sortable: true },
        { text: "Primary color", value: "Primary_color", title: 'Primary color', sortable: true },
        { text: "Creating Date", value: "Creating_date", title: 'Creating Date', sortable: true },
        { text: "ACTIONS", value: "actions", title: 'ACTIONS', sortable: true }
      ],
      editingMeasurement: null,
      snackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      centerLoading: false,
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true,  // Snackbar position top
      },
    };
  },
  computed: {
    totalMeasurements() {
      const count = this.measurementUnits.length;
      // Add leading zero if the count is below 10
      return count < 10 ? `0${count}` : count.toString();
    },
    totalPages() {
      return Math.ceil(this.measurementUnits.length / this.itemsPerPage);
    },

    filteredOrganizations() {
    const searchLower = this.search ? this.search.toLowerCase() : '';

    return this.Organizationset.filter(item => {
      // Ensure values are safely accessed and converted to lowercase
      const orgName = item.organization_name ? item.organization_name.toLowerCase() : '';
      const orgColor = item.organization_color ? item.organization_color.toLowerCase() : '';
      const createdDate = item.created_at ? new Date(item.created_at).toISOString().split('T')[0] : '';

      // Check if the search term matches any of the fields
      const matchesSearch =
        !this.search || // If no search query, show all items
        orgName.includes(searchLower) ||
        orgColor.includes(searchLower) ||
        createdDate.includes(searchLower);

      return matchesSearch; // Return items that match search
    });
  }
  },
  mounted() {
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
    console.log("Check",this.imageURL);
    this.getAllOrganozation();
    this.getDashboardPermissions();
    const dashboardId = 2;
    this.permissions = getPermissions(dashboardId);

    const savedTheme = JSON.parse(localStorage.getItem('theme'));
    if (savedTheme && savedTheme.primaryColor) {
      document.documentElement.style.setProperty('--primary-color', savedTheme.primaryColor);
    }
  },
  methods: {

    resetTheme() {
      localStorage.removeItem('theme'); // Remove from local storage
      document.documentElement.style.removeProperty('--primary-color'); // Remove runtime style
      this.showSnackbar('Theme reset to default!', 'info');
      // Optionally reload to apply changes everywhere
      // window.location.reload();
    },


    setTheme(item) {
      // Save theme data to local storage
      localStorage.setItem('theme', JSON.stringify({
        primaryColor: item.organization_color,
        logoWeb: item.organization_logo_web,
        logoMobile: item.organization_logo_mobile
      }));

      // Update CSS variable in real-time
      document.documentElement.style.setProperty('--primary-color', item.organization_color);

      // Show success message
      this.showSnackbar('Theme saved successfully!', 'success');

      // Optional: reload page
      // window.location.reload();
    },

  // Get Dashboard
  getAllOrganozation() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`/api/getOganizationDetails?userId=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            }
          })
          .then(response => {
            this.Organizationset = response.data.organizations;
            console.log('Organization:', this.Organizationset);
          })
          .catch(error => {
            console.error('Error fetching Organization:', error);
          });
    },

    getColorName(hex) {
      const color = ntc.name(hex);
      // this.convertColor = color[1];
      return color[1];
    },

    validateForm() {
      // Validate Organization Name
      if (!this.organization.name || !/^[a-zA-Z\s]+$/.test(this.organization.name)) {
        this.showSnackbar('Organization Name is required and should contain only letters and spaces.', 'error');
        return false;
      }

      // Validate Organization Logo - Web
      if (
        (!this.organization.webLogo || this.organization.webLogo.length === 0) &&
        (!this.OrganizationDetails.organization_logo_web || this.OrganizationDetails.organization_logo_web === "Not Found")
      ) {
        this.showSnackbar('Web Logo is required.', 'error');
        return false;
      }

      // Validate Organization Logo - Mobile
      if (
        (!this.organization.mobileLogo || this.organization.mobileLogo.length === 0) &&
        (!this.OrganizationDetails.organization_logo_mobile || this.OrganizationDetails.organization_logo_mobile === "Not Found")
      ) {
        this.showSnackbar('Mobile Logo is required.', 'error');
        return false;
      }

      // Validate Dashboard Permissions - At least one must be selected
      const selectedPermissions = this.permissionsItems.filter(item => item.isOn);
      if (selectedPermissions.length === 0) {
        this.showSnackbar('At least one dashboard permission must be selected.', 'error');
        return false;
      }

      return true; // All validations passed
    },

    async updateOrganizationDetails(){

      try {

          if (!this.validateForm()) {
            console.log("Form validation failed. Fix the errors and try again.");
            return;
          }

          this.centerLoading = true;
          const userId = localStorage.getItem('userId');
          const token = localStorage.getItem("token");

          const formData = new FormData();
          formData.append("userId", userId);
          formData.append("organizationId", this.organizationId);

          console.log("organization ID :",this.organizationId);

          formData.append("organization_name", this.organization.name);

          console.log("OrganizationNmae",this.organization.name);

          if (this.changeColor) {
            // If changeColor is defined, get the color name and append it to formData
            // const colorName = this.getColorName(this.changeColor);
            formData.append('organization_color', this.changeColor);
            console.log('color1 :',this.changeColor );

          } else {
            // Otherwise, use the color from this.product
            const colorName = this.previousColor;
            formData.append('organization_color', colorName);
            console.log('color2 :',colorName );
          }
          // console.log("color",this.organization.color);

          // Handle Web Logo - Convert to Base64 if a new image is selected
                if (this.organization.webLogo && typeof this.organization.webLogo !== 'string') {
                  await this.convertToBase64(this.organization.webLogo[0]).then(base64String => {
                    formData.append("organization_logo_web", base64String);
                  });
                } else {
                  // If no new image, send the existing one
                  formData.append("organization_logo_web", this.OrganizationDetails.organization_logo_web);
                }

                // Handle Mobile Logo - Convert to Base64 if a new image is selected
                if (this.organization.mobileLogo && typeof this.organization.mobileLogo !== 'string') {
                  await this.convertToBase64(this.organization.mobileLogo[0]).then(base64String => {
                    formData.append("organization_logo_mobile", base64String);
                  });
                } else {
                  // If no new image, send the existing one
                  formData.append("organization_logo_mobile", this.OrganizationDetails.organization_logo_mobile);
                }

          const selectedDashboardPermissions = this.permissionsItems
          .filter(item => item.isOn)  // Keep only items where isOn is true
          .map(item => ({
              dashboardId: item.id,
              dashboardName: item.premission_dashboard,
          }));

          console.log("dashboard",selectedDashboardPermissions);
          formData.append("dashboard", JSON.stringify(selectedDashboardPermissions));

          // Step 3: API call to backend
          const response = await axios.post("/api/createOganization", formData, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.status === 200) {
            this.showSnackbar("ORGANIZATION WAS UPDATED SUCCESSFULLY!", "success");
            window.location.href = '/organization-list'
            this.centerLoading = false;
          } else {
            this.showSnackbar("Unexpected response status.", "warning");
            this.centerLoading = false;
          }

          } catch (error) {
          console.log(error);
          this.centerLoading = false;
          }
    },

    OpenOrganizationViewDialog(item){
      console.log("view :" , item);

      this.OrganizationDetails = item;

      this.view_organization_dialog = true;

      this.organizationColor = this.getColorName(this.OrganizationDetails.organization_color);

        // Call function to set dashboard permissions
      if (item.dashboards && Array.isArray(item.dashboards)) {
        this.checkDashboard(item.dashboards);
      }

    },

    OpenOrganizationEditDialog(item){
      console.log("view :" , item);
      this.organizationId = item.id;
      this.OrganizationDetails = item;
      this.previousColor = this.OrganizationDetails.organization_color;
      this.organization.color = this.getColorName(this.OrganizationDetails.organization_color);

      this.organization.name = item.organization_name

      this.edit_organization_dialog = true;
      // Call function to set dashboard permissions
      if (item.dashboards && Array.isArray(item.dashboards)) {
        this.checkDashboard(item.dashboards);
      }
    },

    checkDashboard(organizationDashboards) {

      const toFlag = (value) => Number(value) === 1 || value === true;

      console.log("item",organizationDashboards );
      // Reset all checkboxes to false first
      this.permissionsItems.forEach(permission => {
        permission.isOn = false; // Uncheck all before setting correct values
      });

      // Loop through organization's dashboards and match with permissionsItems
      organizationDashboards.forEach(dashboard => {
        const matchingPermission = this.permissionsItems.find(permission => permission.id == dashboard.dashboard_id);

        if (matchingPermission) {
          matchingPermission.isOn = true; // Enable checkbox
          matchingPermission.permissions = {
            read: toFlag(dashboard.read_premission),   // Set read permission
            write: toFlag(dashboard.write_premission), // Set write permission
            delete: toFlag(dashboard.delete_premission) // Set delete permission
          };
        }
      });

      console.log("Updated permissionsItems:", this.permissionsItems);
    },


    // Get Dashboard
    getDashboardPermissions() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`/api/getDashboard?userId=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            }
          })
          .then(response => {
            const dashboards = response.data.data;
            this.permissionsItems = dashboards.map(dashboard => ({
              id: dashboard.id,
              premission_dashboard: dashboard.premission_dashboard,
              isOn: false,
            }));
            console.log('Dashboard permissions:', this.permissionsItems);
          })
          .catch(error => {
            console.error('Error fetching dashboard permissions:', error);
          });
    },

    // Method to convert a file to a base64 string
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const result = reader.result;
          // Remove the "data:image/png;base64," part
          const base64String = result.split(',')[1];
          resolve(base64String);
        };
        reader.onerror = error => reject(error);
      });
    },

    changeImageWeb(){
      this.isEditingWebImage = true;
    },

    changeImageMobile(){
      this.isEditingMoblieImage = true;
    },
    changeImageWebCancel(){
      this.isEditingWebImage = false;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    triggerFileInputMobile(){
      this.$refs.fileInputMobile.click();
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFiles(file);
      }
      event.target.value = '';
    },

    onFileChangeMobile(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFilesMobile(file);
      }
      event.target.value = '';
    },

    handleFiles(file) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        alert('Only image files are allowed!');
        return;
      }

      // Clear previous image
      this.organization.webLogo = [];
      this.previewImages = [];

      this.organization.webLogo.push(file);
      this.previewImages.push(URL.createObjectURL(file));
    },

    handleFilesMobile(file) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        alert('Only image files are allowed!');
        return;
      }

      // Clear previous image
      this.organization.mobileLogo = [];
      this.previewImagesMobile = [];

      this.organization.mobileLogo.push(file);
      this.previewImagesMobile.push(URL.createObjectURL(file));
    },

    removeImage(index) {
      if (index >= 0 && index < this.organization.webLogo.length) {
        this.organization.webLogo.splice(index, 1);
        this.previewImages.splice(index, 1);
      }
    },

    removeImageMobile(index) {
      if (index >= 0 && index < this.organization.mobileLogo.length) {
        this.organization.mobileLogo.splice(index, 1);
        this.previewImagesMobile.splice(index, 1);
      }
    },

    // Calculate character count
    calculateCharCount(html) {
      if (!html) return 0;
      const text = html.replace(/<[^>]+>/g, ''); // Remove HTML tags
      return text.length; // Count characters
    },

    // Handle editor content change
    handleEditorChange() {
      const text = this.valueHtml.replace(/<[^>]+>/g, ''); // Remove HTML tags
      if (text.length > this.charLimit) {
        this.showSnackbar(`Maximum limit of ${this.charLimit} characters reached.`, 'error');
        // this.valueHtml = text.substring(0, this.charLimit); // Truncate input
      }
      this.charCount = this.calculateCharCount(this.valueHtml);
    },
    // image view
    updateImage(src, caption) {
      this.imageSrc = src;
      this.caption = caption;
    },

    async saveMeasurement() {
      // Validate character count
      if (this.charCount > this.charLimit) {
        this.showSnackbar(`Description must be ${this.charLimit} characters or less.`, 'error');
        return;
      }

      if (!this.measurementName || !this.unit) {
        this.showSnackbar('Measurement Name and Unit are required!', 'error');
        return;
      }
      const textOnlyRegex = /^[A-Za-z\s]+$/;
      if (!textOnlyRegex.test(this.measurementName) || !textOnlyRegex.test(this.unit)) {
        this.showSnackbar('Only letters and spaces are allowed for Measurement Name and Unit!', 'error');
        return;
      }

      if (this.editingMeasurement) {
        console.log("Edit function");
      } else {
        console.log("Insert function");
      }
    },


    removeItem(item) {
      this.bulkItems = this.bulkItems.filter(i => i !== item); // Remove the item from the list
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },







    confirmDelete(item) {
      console.log('Deleting item:', item.id);
      this.selectedProductId = item.id;
      this.delete_measurement_dialog = true;
    },

    getSanitizedHTML(html) {
      return DOMPurify.sanitize(html);
    },
    stripHtmlTags(html) {
      // Create a temporary div element
      const tempDiv = document.createElement("div");
      // Set the HTML content to the input
      tempDiv.innerHTML = html;
      // Return the text content without HTML tags
      return tempDiv.textContent || tempDiv.innerText || "";
    },


    // openDialog() {
    //   this.dialogTitle = 'CREATE MEASUREMENTS';
    //   this.dialogButtonText = 'CREATE';
    //   this.measurementName = '';
    //   this.unit = '';
    //   this.valueHtml = '<p></p>'; // Reset valueHtml
    //   this.editingMeasurement = null;
    //   this.dialog = true;
    // },
    // closeDialog() {
    //   this.dialog = false;
    // },

    editMeasurement(item) {
      this.dialogTitle = 'EDIT MEASUREMENTS';
      this.dialogButtonText = 'UPDATE';
      this.measurementName = item.name;
      this.unit = item.unit;
      this.valueHtml = item.description; // Update valueHtml with description
      this.editingMeasurement = item;
      this.dialog = true;
    },

    async deleteItems() {
      // console.log("Delete function");
      // this.delete_measurement_dialog = true;

      localStorage.removeItem('theme'); // Remove from local storage
      document.documentElement.style.removeProperty('--primary-color'); // Remove runtime style
      this.showSnackbar('Theme reset to default!', 'info');

      this.defaulttheme_dialog= false;
      window.location.reload();

    },

    async exportPDF() {
    const doc = new jsPDF();

    // Load images (ensure Base64 format or accessible publicly)
    const logo1 = require('@/img/company_logo/g-sfa.png'); // Adjust the path
    const logo2 = require('@/img/company_logo/logo_full_5.png'); // Adjust the path

    // Add logos on the same line
    doc.addImage(logo1, 'PNG', 14, 10, 20, 10);
    doc.addImage(logo2, 'PNG', 40, 10, 20, 10);

    // Title with gray color and border
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(128, 128, 128);
    doc.text("COMPREHENSIVE ORGANIZATION DATASET REPORT.", 20, 40);
    doc.setDrawColor(192, 192, 192);
    doc.rect(14, 30, doc.internal.pageSize.width - 28, 20, 'S');

    // Box for total organizations count (Move it to the left)
    doc.setFillColor(0, 102, 204);
    doc.setDrawColor(0, 102, 204);
    doc.rect(doc.internal.pageSize.width - 85, 33, 15, 15, 'FD'); // Adjusted to move left
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.text(this.Organizationset.length.toString(), doc.internal.pageSize.width - 80, 41.5); // Adjusted to align with box

    // "TOTAL ORGANIZATIONS" label (Shift left by 3px)
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(0, 0, 0);
    doc.rect(doc.internal.pageSize.width - 58, 33, 35, 15, 'S'); // Adjusted to move left
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(7);
    doc.text("TOTAL ORGANIZATIONS", doc.internal.pageSize.width - 53, 41.5); // Adjusted to align with box

    // Title below card
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("ORGANIZATION DATASET DETAILS", 14, 65);

    // Table headers
    const tableColumn = ["Logo", "Organization", "Primary Color", "Creating Date"];
    const startY = 70; // Start position for table

    // Render table headers
    doc.autoTable({
        head: [tableColumn],
        startY: startY,
        headStyles: { fillColor: [245, 245, 245], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 10 },
        bodyStyles: { fontSize: 9 },
        columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 70 },
            2: { cellWidth: 40 },
            3: { cellWidth: 50 }
        },
        styles: { cellPadding: 4, overflow: 'linebreak' },
        theme: 'grid',
    });

    let yPosition = doc.autoTable.previous.finalY + 5; // Move below headers

    // Render table rows with images and color boxes
    for (const item of this.Organizationset) {
        const img = new Image();
        img.src = item.logo_web; // Make sure it's a valid image URL or Base64

        doc.addImage(img, 'JPEG', 14, yPosition, 15, 15);
        doc.text(item.Organization, 40, yPosition + 5);

        // Draw the color box and add the color code
        const colorHex = item.Primary_color; // Assuming it's a valid hex color code
        doc.setFillColor(colorHex); // Fill with the color
        doc.rect(110, yPosition, 15, 15, 'FD'); // Draw color box

        // Add the color code below the box
        doc.setTextColor(0, 0, 0); // Black text for color code
        doc.setFontSize(8); // Slightly smaller font for the color code
        doc.text(colorHex, 110, yPosition + 18); // Adjusted position for the color code

        doc.text(item.Creating_date, 150, yPosition + 5);

        yPosition += 25; // Adjust row spacing
    }

    // Save the PDF
    doc.save('Organization_Dataset_Report.pdf');
},

    exportExcel() {
      console.log("Exporting to Excel");

      // Prepare worksheet data
      const worksheetData = [
        ['Measurement Name', 'Unit', 'Description'], // Headers
        ...this.measurementUnits.map(item => [
          item.name,
          item.unit,
          this.stripHtmlTags(item.description),
        ])
      ];

      // Create worksheet and apply formatting
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Apply header styling
      const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "0070C0" } }, // Blue background
          alignment: { horizontal: 'center', vertical: 'center' },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          }
        };
      }

      // Apply body alignment and alternating row colors
      for (let R = 1; R <= headerRange.e.r; ++R) {
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellAddress]) continue;

          worksheet[cellAddress].s = {
            alignment: { horizontal: 'left', vertical: 'center' },
            fill: { fgColor: { rgb: R % 2 === 0 ? "F0F0F0" : "FFFFFF" } }, // Alternating row color
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } }
            }
          };
        }
      }

      // Set column widths for better alignment
      worksheet['!cols'] = [
        { wch: 30 }, // Measurement Name
        { wch: 15 }, // Unit
        { wch: 50 }  // Description
      ];

      // Create workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Measurements');

      // Export the workbook to Excel file
      XLSX.writeFile(workbook, 'example.xlsx');


    },
    changePage(newPage) {
      this.page = newPage;
    },
    addProductsPageRoute() {
      console.log("Navigating to bulk upload");
    },
    backPageRoute() {
      console.log("Going back");
    }
  },


}
</script>

<style scoped>
.custom_card_title {
  font-weight: bold;
  /* Makes the text bold */
  font-size: 1.2rem;
  /* Increases the font size slightly */
}
.product-image {
            padding: 4px !important;
            width: 60px;
            height: 60px;
            border: 2px solid #dcdcdc;
            border-radius: 6px;
            background-color: white;
        }


        .drop-area {
  padding: 20px;
  margin-top: 0px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  background-color: #f0f0f0;
  border: 2px dashed #ccc;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  padding-top: 13px;
  height: 216px;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-card {
  position: relative;
  width: 100px;
  height: 100px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: white;
  border-radius: 50%;
}

.hidden-file-input {
      display: none;
    }


    .color-box {
    width: 50px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
  .color-code {
    font-size: 14px;
    font-weight: bold;
  }

</style>